export default __webpack_public_path__ + "static/media/do_more_logo.60d34bde.png";